import { useEffect } from 'react';

const ClaritySetup = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      (function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
        t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
      })(window, document, "clarity", "script", "rrnlkvu4p3");
    }
  }, []);

  return null;
};

export default ClaritySetup;